Vue.component('range-slider', {
    template: '<div></div>',
    props: ['minValue', 'maxValue', 'valueOne', 'valueTwo'],

    data: function(){
        return {

        }
    },
    mounted: function () {
        this.createSlider();
    },
    methods : {
        createSlider : function(){
            var vm = this;
            $(this.$el).slider({
                range: true,
                min: vm.minValue,
                max: vm.maxValue,
                values: [vm.minValue, vm.maxValue],
                slide: function (event, ui) {
                    var values = {
                        min: ui.values[0],
                        max: ui.values[1]
                    };
                    vm.$emit('input', values)
                }
            });

            vm.$emit('input', {
                min: vm.minValue,
                max: vm.maxValue
            })

        },
        resetSlider: function(){
            $(this.$el).slider("destroy");
            this.createSlider();
        },
    },

    watch : {
         maxValue : function(){ this.resetSlider();  }
    },
});
